import {ApiVacationResponder} from '../../../models/api/vacationResponderModel';
import {fetchApiAsync} from '../../../services/http/http';
import {findVacationResponderQueue} from '../../../services/tasks/specializedTaskQueues';
import {ThunkAction} from '../../appThunk';
import {getCompany} from '../company/companySelectors';

export function pushUpdateVacationResponderAction(vacationResponderId: number): ThunkAction {
  return async (dispatch, getState) => {
    // Find the queue for this vacation responder.
    const queue = findVacationResponderQueue(dispatch, getState, vacationResponderId);

    // Wait for our turn to work, then update the vacation responder.
    await queue.waitForTurnAsync();

    const company = getCompany(getState());
    const url = `${company.url}/vacation_responders/${vacationResponderId}`;
    try {
      const vacationResponder = await fetchApiAsync(ApiVacationResponder, url);
      queue.provideResultAsync({
        vacationResponders: [vacationResponder],
        updatedAt: vacationResponder.updatedAt,
      });
    } catch (error) {
      queue.reportError();
      throw error;
    }
  };
}
